module.exports = __webpack_public_path__ + "img/BG_white.d8721581.png";